module.exports = __webpack_public_path__ + "img/comment-icon.6fa73507.svg";